var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChatDeletei = function SvgChatDeletei(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M9.586 16.5a.873.873 0 0 1-.837-.9V9.48a.374.374 0 0 1 .359-.384.373.373 0 0 1 .358.384v6.12a.124.124 0 0 0 .119.124h4.7a.125.125 0 0 0 .119-.128v-6.12a.374.374 0 0 1 .358-.384.374.374 0 0 1 .358.384v6.12a.872.872 0 0 1-.837.9zm2.948-2.177v-4.111a.372.372 0 0 1 .358-.373.372.372 0 0 1 .359.373v4.111a.374.374 0 0 1-.359.384.374.374 0 0 1-.358-.384zm-1.908 0v-4.111a.372.372 0 0 1 .357-.373.372.372 0 0 1 .358.372v4.123a.372.372 0 0 1-.358.373.373.373 0 0 1-.357-.384zm2.334-5.506H8.359A.374.374 0 0 1 8 8.433v-.011a.372.372 0 0 1 .359-.373h2.2v-.165a.374.374 0 0 1 .358-.384h2.042a.372.372 0 0 1 .358.373v.176h2.2a.373.373 0 0 1 .358.374v.01a.374.374 0 0 1-.358.384z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChatDeletei);
export default ForwardRef;